import { useQuery } from "@apollo/client";
import { graphql } from "~/gql";

export const HAS_INVOICES_QUERY = graphql(/* GraphQL */ `
  query HasInvoices {
    hasInvoices
  }
`);

export function useHasInvoicesQuery() {
  return useQuery(HAS_INVOICES_QUERY);
}
